// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nkTW","name":"styles_name__2GCiA","phone":"styles_phone__32VQp"};